
import state from './moduleStatusState.js'
import mutations from './moduleStatusMutations.js'
import actions from './moduleStatusActions.js'
import getters from './moduleStatusGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
